import { Link } from 'react-router-dom';
import { SOCIAL_LINKS, SITE_INFO, NAV_LINKS } from '@lib/constants';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="border-t"
      style={{
        backgroundColor: 'var(--color-theme-2)',
        borderColor: 'var(--color-border-light)'
      }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="md:col-span-2">
            <h3
              className="text-lg font-heading font-bold mb-4"
              style={{ color: 'var(--color-heading)' }}
            >
              {SITE_INFO.name}
            </h3>
            <p
              className="mb-4"
              style={{ color: 'var(--color-card-text)' }}
            >
              {SITE_INFO.tagline}
            </p>
            <p
              className="text-sm"
              style={{ color: 'var(--color-muted)' }}
            >
              {SITE_INFO.location}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-sm font-semibold uppercase tracking-wider mb-4"
              style={{ color: 'var(--color-heading)' }}
            >
              Quick Links
            </h4>
            <ul className="space-y-2">
              {NAV_LINKS.slice(0, 6).map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm transition-colors"
                    style={{ color: 'var(--color-card-text)' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-link-hover)'}
                    onMouseLeave={(e) => e.currentTarget.style.color = 'var(--color-card-text)'}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-sm font-semibold uppercase tracking-wider mb-4"
              style={{ color: 'var(--color-heading)' }}
            >
              Connect
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href={`mailto:${SOCIAL_LINKS.email}`}
                  className="text-sm transition-colors"
                  style={{ color: 'var(--color-card-text)' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-link-hover)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = 'var(--color-card-text)'}
                >
                  Email
                </a>
              </li>
              <li>
                <a
                  href={SOCIAL_LINKS.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm transition-colors"
                  style={{ color: 'var(--color-card-text)' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-link-hover)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = 'var(--color-card-text)'}
                >
                  GitHub
                </a>
              </li>
              <li>
                <a
                  href={`tel:${SOCIAL_LINKS.phone}`}
                  className="text-sm transition-colors"
                  style={{ color: 'var(--color-card-text)' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-link-hover)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = 'var(--color-card-text)'}
                >
                  Phone
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className="mt-8 pt-8 border-t"
          style={{ borderColor: 'var(--color-border-light)' }}
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p
              className="text-sm"
              style={{ color: 'var(--color-card-text)' }}
            >
              © {currentYear} {SITE_INFO.name}. All rights reserved.
            </p>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
